// pieceRenderer.js
import { renderOnePiece } from './renderOnePiece';

// Вспомогательная функция для применения вращения
function applyRotation(ctx, rotation, centerX, centerY) {
  if (rotation !== 0) {
    ctx.translate(centerX, centerY);
    ctx.rotate(rotation * Math.PI / 180);
    ctx.translate(-centerX, -centerY);
  }
}

export function drawPiece(ctx, pieceId, store, options = {}) {
  
  const { ref } = store;
  const { puzzle } = ref;
  const { state } = puzzle;
  const config = state?.config || puzzle.config;
  const piece = state.pieces?.[pieceId];
  const { imageDimensions, boardDimensions } = state;

  if (!piece || !piece.path || !imageDimensions?.width || !boardDimensions?.width) {
    return;
  }

  const puzzleImageElement = state.puzzleImageElement;
  if (!puzzleImageElement || !puzzleImageElement.complete) {
    return;
  }

  const imageScale = state.imageScale;
  const baseWidth = piece.baseDimensions.width * imageScale;
  const baseHeight = piece.baseDimensions.height * imageScale;

  let scaleFactor = options.scaleFactor || 1.0;
  let posRefX, posRefY;
  const isGhost = options.isGhost || false;
  const context = options.context || 'board';
  const rotation = piece.rotation || 0;

  if (context === 'tray') {
    posRefX = options.trayPos.x;
    posRefY = options.trayPos.y;
  } else {
    posRefX = piece.currentPos.x;
    posRefY = piece.currentPos.y;
  }



  const scaledBaseWidth = baseWidth * scaleFactor;
  const scaledBaseHeight = baseHeight * scaleFactor;

  const maxDimension = Math.max(scaledBaseWidth, scaledBaseHeight);
  const maxExtension = maxDimension * config.baseTabSizePercent;
  const maxTotal = maxDimension + maxExtension * 2;

  const baseTabSizePercent = config.baseTabSizePercent;
  const tabExtensionX = (maxTotal - scaledBaseWidth) / 2;
  const tabExtensionY = (maxTotal - scaledBaseHeight) / 2;

  const totalDrawWidth = maxTotal;
  const totalDrawHeight = maxTotal;

  const drawX = posRefX - tabExtensionX;
  const drawY = posRefY - tabExtensionY;

  let pieceOpacity = 1.0;
  let filter = 'none';

  const isPlaced = !isGhost && piece.placed;
  const reserved = !isGhost && !piece.placed && piece.reservedUntil && piece.reservedUntil > Date.now();

  if (isGhost) {
    pieceOpacity = config.ghostOpacity || 0.5;
    filter = 'grayscale(80%) brightness(1.1)';
  } else if (reserved) {
    pieceOpacity = 0.1;
    filter = 'grayscale(100%)';
  }

  let forceRedraw = false;
  // Определяем стиль обводки по умолчанию (один объект)
  let stroke;

  if (piece.onBoard && !piece.placed) {
    // Определяем стиль обводки для выделения (массив из двух объектов)
    const commonWidth = Math.min(4, piece.baseDimensions.width * 0.04);
    const dashPattern = [3, 10];
    stroke = [ // Теперь это массив
      { // Первый стиль (желтый)
        color: '#ffee7c',
        width: commonWidth,
        dash: dashPattern,
        offset: 0
      },
      { // Второй стиль (темный, со смещением)
        color: '#333333',
        width: commonWidth,
        dash: dashPattern,
        offset: 6 // Смещение равно длине первого штриха
      }
    ];
    forceRedraw = true;
  }

  let pieceCanvas = renderOnePiece(
    piece, puzzleImageElement, {
      tabSizePercent: baseTabSizePercent,
      stroke, // Передаем либо объект, либо массив
      forceRedraw,
  });

  ctx.save();
  
  // Центр вращения - центр кусочка с учетом выступов
  const centerX = drawX + totalDrawWidth / 2;
  const centerY = drawY + totalDrawHeight / 2;

  // Применяем вращение вокруг центра
  applyRotation(ctx, rotation, centerX, centerY);

  // Применяем эффекты
  ctx.globalAlpha = pieceOpacity;
  if (filter !== 'none') {
    ctx.filter = filter;
  }

  ctx.drawImage(pieceCanvas, drawX, drawY, totalDrawWidth, totalDrawHeight);

  ctx.restore();
}